import { render, staticRenderFns } from "./AcaoObjetoAuditoriaTab.vue?vue&type=template&id=c8ae3abc&scoped=true"
import script from "./AcaoObjetoAuditoriaTab.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoAuditoriaTab.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoAuditoriaTab.vue?vue&type=style&index=0&id=c8ae3abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ae3abc",
  null
  
)

export default component.exports